<script setup>
const props = defineProps({
  image: {
    type: Object,
    required: true,
  },
  info: {
    type: String,
    required: false,
  },
})
</script>

<template>
  <div class="row justify-content-center">
    <div class="col-12 col-800-10">
      <div class="image">
        <NuxtImg
          v-if="props.image?.src"
          sizes="sm:340px md:440px lg:800px"
          densities="1x 2x"
          :src="props.image?.src"
          :alt="props.image?.alt"
          loading="lazy"
          format="webp"
          :placeholder="[300, 200, 60, 2]"
        />
      </div>
    </div>
    <div
      v-if="props.info"
      class="col-12 col-800-10 col-1200-8 equal-small-1 info"
    >
      {{ props.info }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.image {
  height: 60vh;
  min-height: 400px;
  max-height: clamp(400px, 27.78vw + 311.11px, 800px);

  @include media-breakpoint-down(560) {
    margin-left: $padding-container-negative;
    margin-right: $padding-container-negative;
    width: auto;
  }

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    overflow: hidden;
  }
}

.info {
  color: #999999;
  margin-top: 30px;
}
</style>
